import * as Linking from 'expo-linking';

import * as Updates from './Updates/Updates';

export { Updates, Linking };
